import { render, staticRenderFns } from "./FormerYearOchart.vue?vue&type=template&id=af91e3f2&scoped=true"
import script from "./FormerYearOchart.vue?vue&type=script&lang=js"
export * from "./FormerYearOchart.vue?vue&type=script&lang=js"
import style0 from "./FormerYearOchart.vue?vue&type=style&index=0&id=af91e3f2&prod&lang=css"
import style1 from "../../statistics/css/departmentOchart.css?vue&type=style&index=1&id=af91e3f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91e3f2",
  null
  
)

export default component.exports